import { message } from "antd";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { StringeeCall, StringeeClient } from "stringee-chat-js-sdk";
import ringtoneAudio from "../../assets/audio/ringring.mp3";
import CallConsumer from "../../components/CallConsumer/CallConsumer";

const signalingstate = {
  reject: 5,
  hangup: 6,
};

const mediastate = {
  connect: 1,
  reject: 6,
  disconnect: 2,
};
const CallPage = () => {
  const ringtone = useRef(new Audio(ringtoneAudio));
  const client = useRef(new StringeeClient());
  const remoteVideo = useRef<any>(null);
  const call = useRef<any>();
  const linkRef = useRef<any>();

  const [searchParams] = useSearchParams();
  const [muted, setMuted] = useState(false);
  const [audio, setAudio] = useState(true);
  const [count, setCount] = useState(0);
  const [countCalling, setCountCalling] = useState(0);
  const [isCalling, setIsCalling] = useState(false);
  const [isAnswered, setIsAnswer] = useState(false);
  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
  const [userId, setUserId] = useState();

  function loginStringee(token: string) {
    client.current.connect(token);

    client.current.on("connect", () => {
      console.log("connected");
    });

    client.current.on("authen", (res: any) => {
      console.log("authen", res);
    });

    client.current.on("authensuccess", (res: any) => {
      console.log("authensuccess", res);

      const consumerId = searchParams.get("consumerId");
      if (!consumerId) {
        message.error("Dont have consumer ID");
        return;
      }
      setUserId(res.userId);
      // callUser(res.userId, consumerId);
    });

    client.current.on("disconnect", () => {
      console.log("disconnected");
    });

    client.current.on("requestnewtoken", () => {
      console.log(
        "++++++++++++++ requestnewtoken; please get new access_token from YourServer and call client.connect(new_access_token)+++++++++"
      );
      //please get new access_token from YourServer and call:
      //client.connect(new_access_token);
    });
  }

  function settingCallEvent(call1: any) {
    call1.on("addremotestream", function (stream: any) {
      // reset srcObject to work around minor bugs in Chrome and Edge.
      console.log("addremotestream");
      remoteVideo.current.srcObject = null;
      remoteVideo.current.srcObject = stream;
    });

    call1.on("addlocalstream", function (stream: any) {
      // reset srcObject to work around minor bugs in Chrome and Edge.
      console.log("addlocalstream");
      // localVideo.current.srcObject = null;
      // localVideo.current.srcObject = stream;
    });

    call1.on("signalingstate", function (state: any) {
      console.log("signalingstate ", state);
      if (state.code === signalingstate.reject || state.code === signalingstate.hangup) {
        ringtone.current.loop = false;
        ringtone.current.pause();
        setOpenConfirmPopup(true);
      }
    });

    call1.on("mediastate", function (state: any) {
      console.log("mediastate ", state);
      if (state.code === mediastate.connect && state.reason === "Connected") {
        setIsAnswer(true);
        ringtone.current.loop = false;
        ringtone.current.pause();
      }

      if (state.code === mediastate.reject && state.reason === "Busy here") {
        ringtone.current.loop = false;
        ringtone.current.pause();
        hangup();
        setOpenConfirmPopup(true);
      }

      if (state.code === mediastate.disconnect && state.reason === "Disconnected") {
        hangup();
        setOpenConfirmPopup(true);
      }
    });

    call1.on("info", function (info: any) {
      console.log("on info:" + JSON.stringify(info));
    });
  }

  function callUser(merchantId: string, toUser: string) {
    call.current = new StringeeCall(client.current, merchantId, toUser, false);
    const payload = {
      userId: toUser,
      firstName: searchParams.get("firstName"),
      storeId: searchParams.get("storeId"),
      orderId: searchParams.get("orderId"),
      storeName: searchParams.get("storeName"),
    };
    call.current.custom = JSON.stringify(payload);
    settingCallEvent(call.current);

    const permissionName = "microphone" as PermissionName;

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(function (stream) {
        console.log("You let me use your mic!");
        navigator.permissions.query({ name: permissionName }).then(result => {
          console.log({ result });
          if (result.state === "granted") {
            call.current.makeCall(function (res: any) {
              ringtone.current.loop = true;
              ringtone.current.play();
              setIsCalling(true);
            });
          } else {
            message.error("Microphone Permission is not granted");
          }
          // Don't do anything if the permission was denied.
        });
      })
      .catch(function (err) {
        console.log("No mic for you!");
      });
  }

  function hangup() {
    remoteVideo.current.srcObject = null;
    call.current.hangup(function (res: any) {
      ringtone.current.loop = false;
      ringtone.current.pause();
      setIsAnswer(false);
      console.log("hangup res", res);
    });
  }

  function mutedCall() {
    setMuted(!muted);
    call.current.mute(!muted);
  }

  function turnOffAudio() {
    setAudio(!audio);
    if (audio) {
      call.current.hold();
    } else {
      call.current.unhold();
    }
  }

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) return;
    loginStringee(token);
  }, [searchParams]);

  useEffect(() => {
    window.addEventListener("beforeunload", () => {
      hangup();
    });
  }, []);

  useEffect(() => {
    const checkAnswered = setInterval(() => {
      if (isAnswered) {
        setCount(prev => prev + 1);
      } else {
        clearInterval(checkAnswered);
      }
    }, 1000);
    return () => {
      clearInterval(checkAnswered);
    };
  }, [isAnswered]);

  useEffect(() => {
    const checkIsCalling = setInterval(() => {
      if (isCalling) {
        if (countCalling === 45) {
          hangup();
          setOpenConfirmPopup(true);
          clearInterval(checkIsCalling);
        }
        setCountCalling(prev => prev + 1);
      }
    }, 1000);
    return () => {
      clearInterval(checkIsCalling);
    };
  }, [isAnswered]);

  return (
    <div style={{ background: "black" }}>
      <CallConsumer
        mutedCall={mutedCall}
        hangupCall={hangup}
        muted={muted}
        turnOffAudio={turnOffAudio}
        audio={audio}
        isAnswered={isAnswered}
        count={count}
        name={searchParams.get("firstName")}
        linkRef={linkRef}
        open={openConfirmPopup}
        call={() => {
          const consumerId = searchParams.get("consumerId");
          if (!consumerId || !userId) {
            message.error("Dont have consumer ID");
            return;
          }
          callUser(userId, consumerId);
        }}
        isCalling={isCalling}
      />

      <video
        ref={remoteVideo}
        id="remoteVideo"
        playsInline
        autoPlay
        style={{ width: "370px", position: "absolute", top: "0" }}
      ></video>
    </div>
  );
};

export default CallPage;
